import { combineReducers } from 'redux';
import moment from 'moment';

import {
  REPORTS_SHIFTS_SET_LIST_SHIFT,
  REPORTS_SHIFTS_SET_LIST_SHIFT_V2,
  REPORTS_SHIFTS_SET_LIST_SHIFT_V3,
  REPORTS_SHIFTS_SET_SHIFT_SUMMARY,
  REPORTS_SHIFTS_SET_START_END_DATE,
  REPORTS_SHIFTS_SET_SHIFT_DETAILS,
  REPORTS_SHIFTS_SET_SELECTED_SHIFT,
  REPORTS_SHIFTS_SET_OUTLETS,
  REPORTS_SHIFTS_SET_CURRENT_PAGE,
  REPORTS_SHIFTS_SET_PAYMENT_METHOD_CATEGORIES,
  REPORTS_SHIFTS_SET_PAGINATION,
} from '../../actions/reports/shifts/constants';
import createReducer from '../../utils/createReducer';

const endDate = createReducer(moment().add(-1, 'years').endOf('year'), {
  [REPORTS_SHIFTS_SET_START_END_DATE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.endDate,
});

const keyword = createReducer('', {});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [REPORTS_SHIFTS_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const page = createReducer(0, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [REPORTS_SHIFTS_SET_CURRENT_PAGE]: (draft, { payload }) => payload.page,
});

const shiftDetails = createReducer(null, {
  [REPORTS_SHIFTS_SET_SHIFT_DETAILS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.shiftDetails,
  [REPORTS_SHIFTS_SET_SELECTED_SHIFT]: (draft, { payload }) => payload,
});

const shifts = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [REPORTS_SHIFTS_SET_LIST_SHIFT]: (draft, { payload }) => payload.shifts,
});

const shiftsV2 = createReducer([], {
  [REPORTS_SHIFTS_SET_LIST_SHIFT_V2]: (draft, { payload }) => payload,
});

const shiftsV3 = createReducer([], {
  [REPORTS_SHIFTS_SET_LIST_SHIFT_V3]: (draft, { payload }) => payload,
});

const shiftSummary = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [REPORTS_SHIFTS_SET_SHIFT_SUMMARY]: (draft, { payload }) => payload.summary,
  }
);

const startDate = createReducer(moment().add(-1, 'years').startOf('year'), {
  [REPORTS_SHIFTS_SET_START_END_DATE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.startDate,
});

const paymentMethodCategories = createReducer(
  {},
  {
    [REPORTS_SHIFTS_SET_PAYMENT_METHOD_CATEGORIES]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.paymentMethodCategories,
  }
);

const pagination = createReducer(
  { page: 1, completed: false },
  {
    [REPORTS_SHIFTS_SET_PAGINATION]: (draft, { payload }) => payload,
  }
);

export default combineReducers({
  endDate,
  keyword,
  outlets,
  page,
  shiftDetails,
  shifts,
  shiftsV2,
  shiftsV3,
  shiftSummary,
  startDate,
  paymentMethodCategories,
  pagination,
});
